// removed by extract-text-webpack-plugin
module.exports = {"input-wrapper":"input-wrapper__3oj6j","input":"input__2V7HN","placeholder":"placeholder__1QtT0","small":"small__1iSWR","visible":"visible__2RsT-"};


//////////////////
// WEBPACK FOOTER
// ./components/form/styles/TextInput.scss
// module id = wM7h
// module chunks = 1